<template>
  <div>
    <mt-navbar v-model="selected" @click.native="tabChange" >
      <mt-tab-item id="1">全部</mt-tab-item>
      <mt-tab-item id="2">待审核</mt-tab-item>
      <mt-tab-item id="3">待操作</mt-tab-item>
      <mt-tab-item id="4">发货中</mt-tab-item>
      <mt-tab-item id="5">待评价</mt-tab-item>
      <mt-tab-item id="8">催评中</mt-tab-item>
      <mt-tab-item id="6">待确认</mt-tab-item>
      <mt-tab-item id="7">已完成</mt-tab-item>
      <mt-tab-item id="10">追评</mt-tab-item>
      <mt-tab-item id="11">追评确认</mt-tab-item>
      <mt-tab-item id="9">已取消</mt-tab-item>
    </mt-navbar>
    <div class="header"></div>
    <!-- tab-container -->
    <mt-tab-container v-model="selected">
      <mt-tab-container-item id="1">
        <van-list
            v-model="isLoading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onRefresh"
        >
          <div v-for="(item, index) in cardData">
            <task-item-component :card-data="item" :key="index" @goToDetail="goToDetail"></task-item-component>
          </div>
        </van-list>
      </mt-tab-container-item>
      <mt-tab-container-item id="2">
        <van-list
            v-model="isLoading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onRefresh"
        >
          <div v-for="(item, index) in cardData">
            <task-item-component :card-data="item" :key="index" @goToDetail="goToDetail"></task-item-component>
          </div>
        </van-list>
      </mt-tab-container-item>
      <mt-tab-container-item id="3">
        <van-list
            v-model="isLoading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onRefresh"
        >
          <div v-for="(item, index) in cardData">
            <task-item-component :card-data="item" :key="index" @goToDetail="goToDetail"></task-item-component>
          </div>
        </van-list>
      </mt-tab-container-item>
      <mt-tab-container-item id="4">
        <van-list
            v-model="isLoading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onRefresh"
        >
          <div v-for="(item, index) in cardData">
            <task-item-component :card-data="item" :key="index" @goToDetail="goToDetail"></task-item-component>
          </div>
        </van-list>
      </mt-tab-container-item>
      <mt-tab-container-item id="5">
        <van-list
            v-model="isLoading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onRefresh"
        >
          <div v-for="(item, index) in cardData">
            <task-item-component :card-data="item" :key="index" @goToDetail="goToDetail"></task-item-component>
          </div>
        </van-list>
      </mt-tab-container-item>
      <mt-tab-container-item id="6">
        <van-list
            v-model="isLoading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onRefresh"
        >
          <div v-for="(item, index) in cardData">
            <task-item-component :card-data="item" :key="index" @goToDetail="goToDetail"></task-item-component>
          </div>
        </van-list>
      </mt-tab-container-item>
      <mt-tab-container-item id="10">
        <van-list
            v-model="isLoading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onRefresh"
        >
          <div v-for="(item, index) in cardData">
            <task-item-component :card-data="item" :key="index" @goToDetail="goToExtraDetail"></task-item-component>
          </div>
        </van-list>
      </mt-tab-container-item>
      <mt-tab-container-item id="11">
        <van-list
            v-model="isLoading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onRefresh"
        >
          <div v-for="(item, index) in cardData">
            <task-item-component :card-data="item" :key="index" @goToDetail="goToExtraDetail"></task-item-component>
          </div>
        </van-list>
      </mt-tab-container-item>
      <mt-tab-container-item id="7">
        <van-list
            v-model="isLoading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onRefresh"
        >
          <div v-for="(item, index) in cardData">
            <task-item-component :card-data="item" :key="index" @goToDetail="goToDetail"></task-item-component>
          </div>
        </van-list>
      </mt-tab-container-item>
      <mt-tab-container-item id="8">
        <van-list
            v-model="isLoading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onRefresh"
        >
          <div v-for="(item, index) in cardData">
            <task-item-component :card-data="item" :key="index" @goToDetail="goToDetail"></task-item-component>
          </div>
        </van-list>
      </mt-tab-container-item>
      <mt-tab-container-item id="9">
        <van-list
            v-model="isLoading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onRefresh"
        >
          <div v-for="(item, index) in cardData">
            <task-item-component :card-data="item" :key="index" @goToDetail="goToDetail"></task-item-component>
          </div>
        </van-list>
      </mt-tab-container-item>
    </mt-tab-container>
    <!--<van-button round type="primary"
                style="width: 60px;height: 60px;position: fixed; left: 42%; bottom: 10px;justify-self: center"
                text="接单"
                @click="reciveOrder">
    </van-button>-->
  </div>
</template>

<script>
import taskItemComponent from '../../components/TaskItemComponent'
import addReviceOrder from '../../components/AddButton'
import {getTaskOrders} from "../../api/system/mobile_taskorder";
import {MessageBox} from "mint-ui";
import {getRole} from "../../api/system/sys_user";
import {filterArrObj} from "../../lib/utils";

export default {
  name: "TackManageList",
  components: {
    taskItemComponent,
    addReviceOrder
  },
  data() {
    return {
      titles: "任务管理",
      selected: 1,
      isLoading: false,
      finished: false,
      cardData: [
      ],
      pagination: {
        pages: 0,
        pageNum: 1,
        pageSize: 20,
        total: null
      },
    }
  },
  mounted() {
    this.$emit("titleChange", "任务管理");
  },
  methods: {
    tabChange(){
      console.log(this.selected)
      getTaskOrders(this.selected, {pageNum: 1, pageSize: 20}).then(res => {
        if (res.success) {
          //this.setData(res.data);
          this.cardData = res.data.records;
          //fix bug
          if (res.data.records.length > 0){
            this.finished = false;
          }else{
            this.finished = true;
          }
        }
      }).catch(err => {
        MessageBox({
          title: '提示',
          message: err.message,
          showCancelButton: true
        });
      });
    },
    goToDetail(detail){
      //console.log(detail)
      if (detail.status == "202204200001"){
        this.$router.push({path: '/home/extrareview', query:detail});
      }else {
        this.$router.push({path: '/home/usertaskdetail', query:detail});
      }
    },
    goToExtraDetail(detail){
      this.$router.push({path: '/home/extrareview', query:detail});
    },
    onRefresh() {
      //console.log("++++++onRefresh++++++++")
      this.isLoading = true;
      this.finished = false;
      getTaskOrders(this.selected, this.pagination).then(res => {
        if (res.success) {
          this.setData(res.data);
          this.pagination.pages = res.data.pages;
          this.pagination.pageNum = res.data.current;
          this.isLoading = false;
          if (this.pagination.pageNum == this.pagination.pages){
            this.finished = true;
          }else{
            this.pagination.pageNum = this.pagination.pageNum + 1;
          }
        }
      }).catch(err => {
        this.isLoading = false;
        this.finished = true;
        MessageBox({
          title: '提示',
          message: err.message,
          showCancelButton: true
        });
      });
    },
    reciveOrder() {
      console.log("recive=======")
      getRole().then(res=>{
        console.log(res);
        if (res.success){
          if (res.data[0] == "anchor"){
            this.$router.push({path: '/home/taskbrocastlist'});
          }else {
            this.$router.push({path: '/home/userordercondition'});
          }
        }
      }).catch(err => {
        MessageBox({
          title: '提示',
          message: err.message,
          showCancelButton: true
        });
      });
    },
    setData(data) {
        if (data.records.length > 0){
          this.cardData.push(...data.records);
          this.cardData = filterArrObj(this.cardData, "id");
        }else{
          this.finished=true;
        }
      let self = this;
      self.$forceUpdate();
    }
  },
  beforeRouteEnter(to, from, next) {
    getTaskOrders(to.query.status !=null?to.query.status:1, {pageNum: 1, pageSize: 20}).then(res => {
      if (res.success) {
        next(vm => {
          vm.selected = to.query.status !=null?to.query.status:"1"
          vm.setData(res.data)
        });
      }
    }).catch(err => {
      MessageBox({
        title: '提示',
        message: err.message,
        showCancelButton: true
      });
    });
  },
}
</script>

<style lang="scss" scoped>
.header {
  line-height: 33px;
  border-bottom: 1px dashed #acacac;
}
</style>
